module.exports = __webpack_public_path__ + "media/images/icons/outlined/pushpin-6ee966c4429a34b4d7af2af996264f0f.svg";